import * as XLSX from 'xlsx';

const MIN_WIDTH = 10;

const getColumnWidths = (rows : Array<object>, columns: Array<string>) => {

  if (! (Array.isArray(rows) && rows.length > 0)) {
    return [];
  }
  
  const samples = rows.slice(0, Math.min(rows.length, 20));

  let cols: any = [];
  columns.forEach(key => {
    //@ts-ignore
    let lengths: number[] = [MIN_WIDTH, key.length];

    samples.forEach( (row: any) => {
      if (! (row && typeof row === 'object' && row.hasOwnProperty(key))) {
        return;
      }
      let length = `${row[key]}`.length;

      lengths.push(Math.min(length ? length : MIN_WIDTH, 50));      
    })
    cols.push({wch : Math.max(...lengths)});
  })

  return cols;
}


export const downloadXLSFile = (rows : Array<object>, columns : Array<string>, filename: string, sheetName: string = 'Sheet1', opts: object = {}) => {
  
  if( ! (rows && rows.length > 0 && columns && columns.length > 0)) {
    return;
  }  

  // set regex for keys starting with flg_
  let _base = {}
  columns.forEach(col => {
    Object.assign(_base, { [`${col}`]: ''});
  })

  // pick columns and convert flg_ keys to binary
  let _picked = rows.map(
    // Map them to [key, value] pairs
    (row: any) => columns.map(key => [key, row.hasOwnProperty(key) ? row[key] : ''])
    // Turn the [key, value] pairs back to an object
    // eslint-disable-next-line 
    .reduce((obj: any, [key, value]) => (obj[key] = value, obj), {})
  );
  
  // https://docs.sheetjs.com/docs/api/utilities/array#array-of-objects-input
  const worksheet = XLSX.utils.json_to_sheet(_picked, { header: columns, ...opts});  
  worksheet["!cols"] = getColumnWidths(_picked, columns);  

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  
  XLSX.writeFile(workbook, `${filename}.xlsx`, { compression: true });  
  
}